var _g, _defs;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgWhatsapp = props => /*#__PURE__*/React.createElement(SvgIcon, props, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#whatsapp_svg__clip0_4851_49034)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.023 19.828l1.395-5.091A9.807 9.807 0 01.106 9.825C.108 4.407 4.517 0 9.935 0a9.768 9.768 0 016.952 2.882 9.764 9.764 0 012.876 6.95c-.002 5.418-4.412 9.826-9.829 9.826H9.93a9.823 9.823 0 01-4.696-1.196l-5.21 1.366z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.938 1.66c-4.506 0-8.17 3.663-8.172 8.166a8.146 8.146 0 001.248 4.346l.195.309-.826 3.013 3.092-.81.299.176A8.158 8.158 0 009.932 18h.003c4.502 0 8.167-3.664 8.169-8.166a8.114 8.114 0 00-2.39-5.778A8.114 8.114 0 009.937 1.66z",
  fill: "url(#whatsapp_svg__paint0_linear_4851_49034)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.48 5.717c-.185-.409-.379-.417-.553-.424l-.471-.006a.902.902 0 00-.655.307c-.225.246-.86.84-.86 2.048 0 1.209.88 2.376 1.003 2.54.123.164 1.699 2.723 4.195 3.707 2.075.818 2.497.655 2.947.615.45-.041 1.453-.595 1.658-1.168.204-.573.204-1.065.143-1.168-.061-.102-.225-.163-.471-.286-.246-.123-1.453-.717-1.678-.8-.225-.081-.389-.122-.553.124-.164.246-.634.799-.777.963-.143.163-.286.184-.532.061-.246-.123-1.037-.382-1.975-1.219-.73-.65-1.223-1.454-1.366-1.7-.144-.246-.015-.379.108-.501.11-.11.245-.287.368-.43.123-.144.164-.246.245-.41.082-.163.041-.307-.02-.43s-.539-1.337-.757-1.823z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "whatsapp_svg__paint0_linear_4851_49034",
  x1: 9.768,
  y1: 2.641,
  x2: 9.851,
  y2: 16.603,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57D163"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23B33A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "whatsapp_svg__clip0_4851_49034"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWhatsapp;